import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './NavigationFixed.css';
import { TNavigationLinkType } from '../../../types';
import { NavigationBar } from '../NavigationBar';

export interface INavigationFixedStoreProps {
  villageName: string;
  links: TNavigationLinkType[];
  isFat?: boolean;
}

interface INavigationFixedOwnProps {
  isActive: boolean;
}

type TNavigationFixedProps = INavigationFixedOwnProps & INavigationFixedStoreProps;

export class NavigationFixedComponent extends React.Component<TNavigationFixedProps> {
  public render() {
    const { isActive, links, villageName, isFat } = this.props;

    return (
      <div {...mergeStyles(styles['container'], isActive && styles['container--active'])}>
        <div className={styles['panel']}>
          <div className={styles['wrapper']}>
            <NavigationBar links={links} isNavigationFixed isFat={isFat} />
          </div>
          <div className={styles['aside']}>
            <div className={styles['description']}>{villageName}</div>
          </div>
        </div>
      </div>
    );
  }
}
